import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import NumericInput from 'ui-library/inputs/NumericInput';
import {NumericInputChangeEvent} from 'util/Types';

import {ExtraFootersTransform} from '../../RunSchemaSpecConstants';
import {ExtraFootersFormErrors, updateTransformationProperties} from './TransformFormUtils';

interface ExtraFootersFormProps {
  transform: ExtraFootersTransform;
  onChange: (transform: ExtraFootersTransform) => void;
  formErrors: ExtraFootersFormErrors;
}

export default function ExtraFootersForm(props: ExtraFootersFormProps): JSX.Element {
  return (
    <Row>
      <Col md={4}>
        <FieldLabel label="Number of rows to remove" isRequired={true} />
        <NumericInput
          min={0}
          value={props.transform.transformationProperties?.numRowsToRemove}
          onChange={(e: NumericInputChangeEvent) => {
            if (e.target.numericValue != null) {
              props.onChange(
                updateTransformationProperties(props.transform, 'numRowsToRemove', e.target.numericValue)
              );
            }
          }}
          validateInteger={true}
          required={props.formErrors.numRowsToRemove}
        />
        {props.formErrors.numRowsToRemove ? (
          <ErrorMessage error="Number of rows to remove is required" />
        ) : null}
      </Col>
    </Row>
  );
}
